import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';

// Use environment variable for API URL
// Lambda Function URL doesn't have /api prefix, routes are /agentic-workflow/...
const API_BASE_URL = process.env.REACT_APP_API_URL || '';

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({ baseUrl: API_BASE_URL }),
  endpoints: (builder) => ({
    validateFramework: builder.mutation({
      query: ({ framework, file }) => {
        const formData = new FormData();
        formData.append('framework', framework);
        formData.append('file', file);
        return {
          url: '/agentic-workflow/validate-framework',
          method: 'POST',
          body: formData,
        };
      },
    }),
    sendContactEmail: builder.mutation({
      query: (contactData) => ({
        url: '/contact',
        method: 'POST',
        body: contactData,
      }),
    }),
    sendFeedback: builder.mutation({
      query: ({ feedback, fileName }) => ({
        url: '/feedback',
        method: 'POST',
        body: { feedback, fileName },
      }),
    }),
  }),
});

export const {
  useValidateFrameworkMutation,
  useSendContactEmailMutation,
  useSendFeedbackMutation,
} = apiSlice;